import { create } from 'zustand';
import {
  RtbCampaign,
  RtbCampaignPlanType,
  CreativeDeliverType,
  DeliverType,
  AdType,
} from 'core/rtbCampaign/RtbCampaign';
import { L2ObjectOptimizationGoal } from 'core/l2Object/L2Object';
import { ActionType } from 'core/rtbCampaign/singlePage/common';

// 通用廣告活動類型
type Campaign = {
  campaign: RtbCampaign;
  adType: AdType;
  actionType: ActionType;
  brand: { value: string; label: string };
  lockBrand: boolean;
  showProductManager: boolean;
  roasList: string[];
  loading: boolean;
  handleSetCampaign: (defaultCampaign: object) => void;
  resetCampaignStore: () => void;
  openProductManager: (open: boolean) => void;
  handleLoading: (loading: boolean) => void;
  handleSelectBrand: (brand: { value: string; label: string }) => void;
  handleSetRoasList: (roasList: string[]) => void;
};
// 活動群組
type CampaignGroup = {
  group: object;
  setGroup: (defaultgroup: object) => void;
};

const defaultCampaign = {
  basic: {
    id: undefined,
    name: '',
    groupId: 0,
    advertiserId: 0,
    orderId: 0,
    budget: 0,
    startDate: '',
    endDate: '',
    createDate: undefined,
    priceModel: RtbCampaignPlanType.RS,
    orderPrice: undefined,
    optimize: {} as L2ObjectOptimizationGoal,
    bidPrice: undefined,
    creativeDeliverType: CreativeDeliverType.OPTIMIZE,
    deliverType: DeliverType.STANDARD,
    state: undefined,
    effectiveStatus: undefined,
    spents: undefined,
    currencyRate: undefined,
    olapActualSpent: undefined,
    olapExpectSpent: undefined,
    expectedSpent: 0,
    impres: undefined,
    clicks: undefined,
    dailyTargetBudget: null,
    frequency: undefined,
    dayPart: undefined,
    checkpoints: [],
    dealIds: undefined,
    adType: AdType.UNKNOWN,
    additionalInfo: undefined,
    bindings: undefined,
    report: undefined,
    ageMin: 0,
    ageMax: 0,
    webBrandNo: undefined,
    selectPattern: null,
    budgetType: null,
    runningPattern: null,
    roasStrategy: undefined,
  },
  limitations: {
    include: [],
    exclude: [],
    preferred: [],
    nonPreferred: [],
    other: undefined,
  },
};

export const useCampaignStore = create<Campaign>()((set) => ({
  campaign: {
    basic: {
      id: undefined,
      name: '',
      groupId: 0,
      advertiserId: 0,
      orderId: 0,
      budget: 0,
      startDate: '',
      endDate: '',
      createDate: undefined,
      priceModel: RtbCampaignPlanType.RS,
      orderPrice: undefined,
      optimize: {} as L2ObjectOptimizationGoal,
      bidPrice: undefined,
      creativeDeliverType: CreativeDeliverType.OPTIMIZE,
      deliverType: DeliverType.STANDARD,
      state: undefined,
      effectiveStatus: undefined,
      spents: undefined,
      currencyRate: undefined,
      olapActualSpent: undefined,
      olapExpectSpent: undefined,
      expectedSpent: 0,
      impres: undefined,
      clicks: undefined,
      dailyTargetBudget: null,
      frequency: undefined,
      dayPart: undefined,
      checkpoints: [],
      dealIds: undefined,
      adType: AdType.UNKNOWN,
      additionalInfo: undefined,
      bindings: undefined,
      smartCampaignConfigId: undefined,
      report: undefined,
      ageMin: 0,
      ageMax: 0,
      webBrandNo: undefined,
      selectPattern: null,
      budgetType: null,
      runningPattern: null,
      roasStrategy: undefined,
    },
    limitations: {
      include: [],
      exclude: [],
      preferred: [],
      nonPreferred: [],
      other: undefined,
    },
  },
  adType: AdType.UNKNOWN,
  actionType: ActionType.UNKNOWN,
  brand: { value: '', label: '' },
  lockBrand: false,
  showProductManager: false,
  roasList: ['-', '-', '-'],
  loading: false,
  handleSetCampaign: (defaultCampaign) =>
    set((state) => ({
      campaign: { ...state.campaign, ...defaultCampaign },
    })),
  resetCampaignStore: () =>
    set(() => ({
      campaign: defaultCampaign,
      adType: AdType.UNKNOWN,
      actionType: ActionType.UNKNOWN,
      brand: { value: '', label: '' },
      lockBrand: false,
      showProductManager: false,
      loading: false,
    })),
  handleLoading: (loading) => set(() => ({ loading })),
  handleSelectBrand: (brand) => set(() => ({ brand })),
  handleSetRoasList: (roasList) => set(() => ({ roasList })),
  openProductManager: (open) => set(() => ({ showProductManager: open })),
}));

export const useCampaignGroupStore = create<CampaignGroup>()((set) => ({
  group: {},
  setGroup: (defaultgroup) => set(() => ({ group: defaultgroup })),
}));
